import { performIssuePostRequest } from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';
import type { GraphqlResponse, ViewWorkflowData } from './types.tsx';

type IssueKey = string;

const query = `
query classicViewWorkflowQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        workflow {
            name
            step {
                id
            }
        }
    }
}
`;

export const transformResponse = (response: GraphqlResponse): ViewWorkflowData => {
	if (response.data && response.data.viewIssue && response.data.viewIssue.workflow) {
		return {
			workflowName: response.data.viewIssue.workflow.name,
			currentStepId: response.data.viewIssue.workflow.step.id,
		};
	}

	throw new Error('TransformError');
};

export const getViewWorkflowData = (issueKey: IssueKey) =>
	performIssuePostRequest(
		'/rest/gira/1/',
		{
			body: JSON.stringify({
				query,
				variables: { issueKey },
			}),
		},
		'fields/status/src/services/classic-view-workflow-service/utils',
	).then(transformResponse);
